import Api from './api.service'

export default {
  createLPProfile (object) {
    return Api().post('lpProfile/create', object)
  },
  updateLPProfile (object) {
    return Api().put('lpProfile/edit/' + object.id, object.object)
  },
  lpProfileList (filter) {
    return Api().get('lpProfile/get', { params: filter })
  },
  getLPProfile (id) {
    return Api().get('lpProfile/get/' + id)
  }
}